import { useRef } from 'react';
import { useResizeObserver } from 'usehooks-ts';

export interface TriggerWidth {
  groupRef: React.RefObject<HTMLDivElement>;
  groupWidth: number | undefined;
}

export function useTriggerWidth(): TriggerWidth {
  const groupRef = useRef<HTMLDivElement>(null);

  // Read the content-box width (contentBoxSize.inlineSize, with a contentRect.width fallback) so the popover matches the trigger's inset content width, not the border-box outer width.
  const { width: groupWidth } = useResizeObserver({ ref: groupRef, box: 'content-box' });

  return { groupRef, groupWidth };
}
